import React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ProductModel } from "../../entities/admin.product.model";
import { getEffectivePrice } from "../../utils/shared.utils";
import "./top-product.scss";

interface ProductProps {
  product: ProductModel;
  client?: any;
}

const mapStateToProps = (state: any) => ({
  client: state.client,
});

class TopProductItem extends React.Component<ProductProps> {
  render() {
    const p = this.props.product;
    const isClubMember   = this.props.client?.company?.clubMember;
    const effectivePrice = getEffectivePrice(p, isClubMember);
    const isSale         = (p as any).saleActive && (p as any).salePrice > 0;
    const isClub         = !isSale && isClubMember && (p as any).clubPrice > 0;
    const showStrike     = effectivePrice !== p.price;
    const imageRaw = p.imageSmUrl || p.imageXsUrl || p.imageLgUrl || (p as any).image1 || "";
    const imageUrl = imageRaw && !/^https?:\/\//i.test(imageRaw)
      ? `https://${process.env.REACT_APP_AWS_S3_BUCKET}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${imageRaw}`
      : imageRaw;
    const safeImageUrl = imageUrl ? encodeURI(imageUrl) : "";
    let priceBlock;
    if (showStrike && isClubMember && !isSale) {
      priceBlock = (
        <>
          <div className='original-line'>
            <span className='original-price'>
              <NumberFormat displayType={"text"} className='club-original-price' value={p.price} suffix=' ₮' thousandSeparator={true} />
            </span>
            { p.size && p.unit
              ? <span className='unit-text'> / {p.size} {p.unit}</span>
              : null
            }
          </div>
          <div className='price-block discounted'>
            <div className={`price-type-label ${'club'}`}>
              {'CLUB PRICE' }
            </div>
            <div className='effective-price'>
              <NumberFormat displayType={"text"} value={effectivePrice} suffix=' ₮' thousandSeparator={true} />
            </div>
          </div>
        </>
      );
    } else if (showStrike && isSale) {
      priceBlock = (
        <>
          <div className='original-line'>
            <span className='original-price'>
            <div className='price-type-label sale'>SALE</div>
            <NumberFormat displayType={"text"} value={p.price} suffix=' ₮' thousandSeparator={true} />
            </span>
          </div>
          <div className='price-block'>
            <div className='effective-price'>
              <NumberFormat displayType={"text"} value={p.salePrice} suffix=' ₮' thousandSeparator={true} />
              { p.size && p.unit
                ? <span className='unit-text'> / {p.size} {p.unit}</span>
                : null
              }
            </div>
          </div>
        </>
      );
    } else {
      priceBlock = (
        <>
          <div className='effective-price'>
            <NumberFormat displayType={"text"} value={p.price} suffix=' ₮' thousandSeparator={true} />
          </div>
        </>
      );
    }

    return (
      <div className='top-product-item'>

        <Link className='product-img-cntnr' to={"/product/" + p.slug}>
          <div
            className='product-image'
            style={safeImageUrl ? { backgroundImage: `url(${safeImageUrl})` } : undefined}
          />
        </Link>

        <div className='card-content'>
          <Link to={"/product/" + p.slug} className='product-name'>
            {p.shortName || p.name} <span className='product-name-badge'>({p.size} {p.unit})</span>
          </Link>
          <div className='product-info'>{p.info}</div>
          {priceBlock}
        </div>

      </div>
    );
  }
}

export default connect(mapStateToProps)(TopProductItem);
